var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iconUrl)?_c('div',{staticClass:"ui-label-badge-icon",style:({ backgroundImage: ("url(" + _vm.iconUrl + ")") }),on:{"click":function($event){$event.stopPropagation();return _vm.handleIconClick.apply(null, arguments)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }